import React from 'react';
import {BrowserRouter as Router, Route, Switch}from 'react-router-dom'

import Landing from '../pages/Landing/App';
import FAQ from '../pages/FAQ';
import Redirect from '../components/Redirect';
import Survey from '../pages/Survey';
import Plans from '../pages/Plans';
import FreeRegistration from '../pages/FreeRegistration';
import Registration from '../pages/Registration';
import CookieBanner from '../components/CookieBanner';
import Hardlock from '../pages/Hardlock';

const Main = () => {
    return (
        <Router>
            <Switch>
                <Route exact={true} path="/" component={Landing} />
                <Route exact={true} path="/faq" component={FAQ} />
                <Route exact={true} path="/survey/:id" component={Survey} />
                <Route exact={true} path="/plans" component={Plans} />
                <Route exact={true} path="/freeregistration" component={FreeRegistration} />
                <Route exact={true} path="/registration/:planCode" component={Registration} />
                <Route exact={true} path="/hardlock5" component={Hardlock} />
                <Route exact={true} path="/hardlock5/eng" component={Hardlock} />
                <Route component = {Redirect}/>
            </Switch>
            <CookieBanner />
        </Router>
    );
}

export default Main;
